<template>
    <div class="table-responsive">
        <table class="table table-striped table-bordered align-items-center">
            <thead>
                <tr class="bg-secondary text-light">
                    <th style="width: 4rem;">{{ TR.rank }}</th>
                    <template v-for="(td, tdi) in table_columns" :key="tdi">
                        <th :class="td.class">{{ td.title }}</th>
                    </template>
                </tr>
            </thead>
            <tbody>
                <template v-for="(item, index) in data" :key="index">
                    <tr>
                        <td>{{ index + 1 }}</td>
                        <template v-for="(td, tdi) in table_columns" :key="tdi">
                            <td :class="td.class">{{ typeof td.value === 'function' ? td.value(item) : item[td.name] }}</td>
                        </template>
                    </tr>
                </template>
            </tbody>
        </table>
    </div>
</template>

<script>
import { ref, watchEffect } from "vue";

    import { useStore } from "@/store";

export default {
    name: 'SimpleTableC',
    props: {
        data: {
            type: Object,
        },
        table_columns: {
            type: Object,
        },
    },

    setup() {
        const store = useStore();

        const TR = ref();

        watchEffect(() => {
            TR.value = store.getTranslation();
        });

        return { TR };
    },
};
</script>


<style lang="scss" scoped>
.table {
    width: 100%;
    margin-bottom: 1rem;
    // color: #7b809a;
    vertical-align: top;
    border-color: #f0f2f5;
}

.table thead th {
    padding: 0.5rem;
    text-transform: uppercase;
    font-weight: bold;
    border-bottom: 1px solid #f0f2f5;
    border-bottom-color: rgb(240, 242, 245);
}

@media print{
    .bg-secondary{
        background-color: #95999c !important;
    }
}
</style>

